import _ from "lodash";
import data from "../data/professioni.json";
export const getProfessione = (professioneId) => {
  let professione = _.findKey(data.professioni, function (o) {
    return o.id === parseInt(professioneId);
  });
  return data.professioni[professione];
};
